import Vue from 'vue'
import App from './App.vue'
import router from './router'
import http from './http/http'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from "./store";
import myNav from '@/components/myNav'
import 'swiper/css/swiper.css'
import AMap from 'vue-amap'
Vue.use(AMap)
// 初始化地图
AMap.initAMapApiLoader({
  key: '1824t81543gdasdg81534681dua34',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']    // 插件集合
})
Vue.component('myNav', myNav)
Vue.use(ElementUI)
Vue.config.productionTip = false
// 给原型对象添加方法
Vue.prototype.$axios = http
// http.defaults.baseURL = '/api'
// http.defaults.headers.post['Content-Type'] = 'application/json';



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
